import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
  decodeCatalogSearch,
  decodeCatalogSearchViewBbox,
} from '../../../lib/catalog-return-context';
import { pickSharedFilterSearch, type SharedFilterFieldId } from '../../../lib/filter-config';
import { ClientDetailBackLink } from './client-detail-back-link';

// A `viewBbox` inside `catalogSearch` is only ever encoded by the map pin popup's "Szczegóły"
// navigation (`map-pin-popup-card.tsx`), so its presence means the user came from /map: link back
// there with the map-shared filter subset plus the persisted viewport (CU-86cb1nq31). Mirrors the
// app-shell sidebar "Mapa" link's restore logic (`mapNavSearch`).
export function MediaUnitDetailBackLink({ catalogSearch }: { catalogSearch?: string }) {
  const { t } = useTranslation('inventory');
  const mapBackSearch = React.useMemo(() => {
    const viewBbox = decodeCatalogSearchViewBbox(catalogSearch);
    if (viewBbox == null) return null;
    // Sound cast: pickSharedFilterSearch only ever picks SHARED_FILTER_FIELD_IDS
    // keys whose values are non-empty string arrays.
    const filters = pickSharedFilterSearch(
      decodeCatalogSearch(catalogSearch) as unknown as Record<string, unknown>,
    ) as Partial<Record<SharedFilterFieldId, string[]>>;
    return { ...filters, viewBbox };
  }, [catalogSearch]);

  return mapBackSearch != null ? (
    <ClientDetailBackLink to="/map" search={mapBackSearch} label={t('detail.backToMap')} />
  ) : (
    <ClientDetailBackLink
      to="/media-units"
      search={decodeCatalogSearch(catalogSearch)}
      label={t('detail.backLink')}
    />
  );
}
